import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';
import {
    AGENT_NAME_SET_VALUE,
    AGENT_NAME_SET_VALID,
    AGENT_CODE_SET_VALUE,
    AGENT_CODE_SET_VALID,
    MODAL_FORM_DISPLAY,
    REINITIALIZE,
    FORM_VALID_MOTOR_INSURANCE_AGENT_MODAL_FORM,
    FORM_INVALID_MOTOR_INSURANCE_AGENT_MODAL_FORM,
    SET_INTERMEDIARY_TYPE_VALUE,
    SET_INTERMEDIARY_TYPE_VALID,
    SET_AGENTS,
    API_PENDING_AGENTS,
    API_SUCCESS_AGENTS,
    API_FAILURE_AGENTS,
} from '../../actions/domesticInsurance/motorAgentModal';

export const initAgents = {
    displayModal: false,
    formStatus: FORM_STATUS.INVALID,
    apiCallStatus: null,
    agents: null,
    form: {
        name: { value: null, error: null, status: null },
        agentCode: { value: null, error: null, status: null },
        intermediaryType: { value: null, error: null, status: null },
    },
};

export default (state = initAgents, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case FORM_VALID_MOTOR_INSURANCE_AGENT_MODAL_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case MODAL_FORM_DISPLAY:
            return { ...state, displayModal: action.value };

        case FORM_INVALID_MOTOR_INSURANCE_AGENT_MODAL_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case API_PENDING_AGENTS:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };
        case API_SUCCESS_AGENTS:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_AGENTS:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };

        // Form
        case AGENT_NAME_SET_VALUE:
            return updateFormField('name', (field) => ({
                ...field,
                value: action.value,
            }));

        case AGENT_NAME_SET_VALID:
            return updateFormField('name', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case AGENT_CODE_SET_VALUE:
            return updateFormField('agentCode', (field) => ({
                ...field,
                value: action.value,
            }));

        case AGENT_CODE_SET_VALID:
            return updateFormField('agentCode', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SET_INTERMEDIARY_TYPE_VALUE:
            return updateFormField('intermediaryType', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_INTERMEDIARY_TYPE_VALID:
            return updateFormField('intermediaryType', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SET_AGENTS:
            return { ...state, agents: action.value };

        // Reset the state
        case REINITIALIZE:
            return initAgents;
        default:
            return state;
    }
};
